<template>
<div class="input-field-wrapper">
    <div class="input-field-group">
        <div class="text-input">
            <input
                    class="font-size-middle"
                    :id="id"
                    :type="computedType"
                    :name="computedName"
                    :placeholder="placeholder"
                    :readonly="readonly"
                    autocomplete="off"
                    @keyup="inputChanged"
                    required
            />
            <label class="font-size-middle" :for="id">{{placeholder}}</label>
        </div>
    </div>
</div>
</template>

<script>
import { uniqueId } from 'lodash';

export default {
    name: 'InputField',
    props: {
        placeholder: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        computedName() {
            const { type } = this;
            let computedName = '';

            if (type === 'text') {
                computedName = 'text';
            } else if (type === 'username') {
                computedName = 'username';
            } else if (type === 'password') {
                computedName = 'password';
            }

            return computedName;
        },

        computedType() {
            const { type } = this;
            let computedType = '';

            if (type === 'text') {
                computedType = 'text';
            } else if (type === 'username') {
                computedType = 'text';
            } else if (type === 'password') {
                computedType = 'password';
            }

            return computedType;
        },
    },
    data() {
        return {
            inputValue: '',
            id: null,
        };
    },
    mounted() {
        this.id = uniqueId('input-field-group-');
    },
    methods: {
        inputChanged(event) {
            this.inputValue = event.target.value;
            this.$emit('input', this.inputValue);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.input-field-wrapper {
    .input-field-group {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    /** Input styling **/
    .text-input {
        position: relative;
        display: block;
        height: 56px;
        width: 100%;
    }

    .text-input > input {
        position: absolute;
        bottom: 0;
        display: block;
        height: 40px;
        width: 100%;
        line-height: 40px;
        border: 0;
        border-bottom: 1px solid $grey-light;
        outline: 0;
        background: transparent;
        color: $grey-light;
        /*   transition: all 1s ease-in-out; */
    }

    .text-input > input::placeholder {
        color: transparent;
    }

    .text-input > label {
        position: absolute;
        top: 25px;
        left: 9px;
        color: $grey-light;
        cursor: text;
        transition: all 0.2s ease-in-out;
    }

    .text-input > input:focus,
    .text-input > input:not(:placeholder-shown) {
        border-bottom: 2px solid $primary;
    }

    .text-input > input:focus + label,
    .text-input > input:not(:placeholder-shown) + label {
        top: 0;
        left: 0;
        font-size: 14px;
        color: $primary;
        padding-top: 0.75rem;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-transition-delay: 9999s;
        -webkit-transition: color 9999s ease-out, background-color 9999s ease-out;
    }

    @media only screen and (max-width: 768px) {
        .text-input{
            margin-bottom: 0;
        }
    }
}
</style>
